// @flow
import { httpClient } from 'angieslist-app-platform';
import queryString from 'query-string';
import type { MetricCategory, MetricsAggregation } from '../types';

export type GetReviewsRequest = {
  serviceProviderId: string,
  categoryId?: number,
  starRatingFilters: number[],
  sortDirection: string,
  sortType: string,
  offset: number,
};

const getReviews = (
  serviceProviderId: string,
  categoryId?: number,
  starRatingFilters: number[],
  sortDirection: string,
  sortType: string,
  limit: number,
  offset: number,
): any => httpClient.get(`/gateway/office-home/v2/service_providers/${serviceProviderId}/reviews?${queryString.stringify({
  categoryId,
  starRatingFilters,
  sortDirection,
  sortType,
  limit,
  offset,
})}`, {
  headers: {
    'X-ANGI-CallerType': 'ServiceProvider',
    'X-ANGI-CallerId': serviceProviderId,
  },
});

export type GetReviewCategoriesRequest = {
  serviceProviderId: string
};

export type GetReviewCategoriesResponse = {
  categories: MetricCategory[],
  metricAggregation: MetricsAggregation,
  displayStarRating?: number,
  displayReviewCount: number,
}

const getReviewCategories = (serviceProviderId: string): any =>
  httpClient.get(`/gateway/office-home/v3/service_provider/${serviceProviderId}/categories/metrics`, {
    headers: {
      'X-ANGI-CallerType': 'ServiceProvider',
      'X-ANGI-CallerId': serviceProviderId,
    },
  });

export type CreateOrUpdateRetortRequest = {
  text: string
};

export type CreateOrUpdateRetortResponse = {
  id: string,
  reviewId: string,
  status: string,
  serviceProviderId: string,
  text: string
}

const createOrUpdateRetort = (
  serviceProviderId: string,
  reviewId: string,
  text: string,
): any => httpClient.put(`/gateway/office-home/v1/service_providers/${serviceProviderId}/reviews/${reviewId}/retort`, {
  headers: {
    'X-ANGI-CallerType': 'ServiceProvider',
    'X-ANGI-CallerId': serviceProviderId,
  },
  body: {
    text,
  },
});

const markReviewsRead = (
  serviceProviderId: string,
  lastReadReviewId: number,
): any => httpClient.post('/gateway/office-home/v1/review/read', {
  headers: {
    'X-ANGI-CallerType': 'ServiceProvider',
    'X-ANGI-CallerId': serviceProviderId,
  },
  body: {
    lastReadReviewId,
  },
});

export default {
  getReviews,
  getReviewCategories,
  createOrUpdateRetort,
  markReviewsRead,
};



// WEBPACK FOOTER //
// ./src/modules/store/common/reviewsService.js